
import quickbooksImg from "../../components/image/assets/quickbooks-logo.svg";

export default function QuickBooksSections() {
  return (
    <section className="bg-page-accent-dark py-6 md:py-5">
      <div className="container-safe flex justify-center">
        <div className="flex w-full max-w-5xl items-center gap-6 max-md:flex-col md:gap-9">
          <img
            src={quickbooksImg}
            alt="Intuit QuickBooks Logo"
            className="h-[45px] w-auto shrink-0"
          />

          <div className="text-background flex-1">
            <h3 className="xs:leading-9 text-3xl leading-7 font-medium tracking-tight">
              Integration With QuickBooks For Easy Accounting
            </h3>
            <p className="xs:mt-0.5 xs:leading-5 mt-2 text-[8px] leading-3 sm:text-xs">
              *QuickBooks is a registered trademark of Intuit Inc. Used for descriptive purposes
              only.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
